import React from "react";

import {
    View,
    Text,
    ScrollView,
    StyleSheet,
    TouchableOpacity,
    Image,
    Dimensions,
    TextInput,
    Platform
} from "react-native";


import {RFValue} from "react-native-responsive-fontsize";
import {Entypo, FontAwesome, FontAwesome5, FontAwesome6, Fontisto, Ionicons} from "@expo/vector-icons";
import Config from "../../Config";
import AntDesign from "@expo/vector-icons/AntDesign";
import Feather from "@expo/vector-icons/Feather";
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import * as Linking from 'expo-linking';

import EvilIcons from '@expo/vector-icons/EvilIcons';


const Words =({navigation})=>{


    let [key,setKey] = React.useState('');
    const startSearch = async () => {
        navigation.navigate('Word',{word : key})
    }


    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <TouchableOpacity style={{flex : 1}} >
                    <Text style={styles.title}>
                        دیکشنری لغات
                    </Text>
                </TouchableOpacity>
                <TouchableOpacity onPress={()=>{navigation.goBack()}}>
                    <Ionicons style={styles.selficon} name="arrow-back" size={24} color="white" />
                </TouchableOpacity>
            </View>
            <View style={{flex:1  , backgroundColor : Config.maincolor , justifyContent:'center' , alignItems: 'center'}}>

                <Text style={styles.headertxt}>
                    واژه یاب
                </Text>
                <Text style={styles.subheadertxt}>
                  کاربرد واقعی کلمات در فیلم و سریال
                </Text>


                <TextInput
                    placeholderTextColor={"#B1B1B1"}
                    placeholder={" کلمه مورد نظر خود را بنویسید"}
                    onChangeText={setKey}
                    value={key}
                    style={{
                        borderRadius : RFValue(10),
                        fontSize: RFValue(18),
                        direction: "rtl",
                        fontFamily: "yk",
                        textAlign: "center",
                        backgroundColor: "white",
                        width : '90%',
                        Height: RFValue(35),
                        padding : RFValue(10),
                    }}
                    keyboardType={"default"}
                    maxLength={39}
                />
                <TouchableOpacity
                    disabled={key ? false : true}
                    onPress={startSearch}
                    style={styles.button}
                >

                    <Text style={styles.buttonText}>{` `}جستجو و تماشای فیلم</Text>
                    <EvilIcons name="search" size={RFValue(32)}  color="white" />
                </TouchableOpacity>
                <Text style={styles.subheadertxt}>
                   نمونه های واقعی از فیلم را ببنید و تلفظش را بشنوید ...
                </Text>
                <Image
                    resizeMode={'stretch'}
                    fadeDuration={999}
                    style={{
                        // width : '90%',
                        width : Dimensions.get('window').width - RFValue(35),
                        height :(Dimensions.get('window').width  + RFValue(40)) * 275 / 974,
                        borderRadius : RFValue(15),
                        marginHorizontal : RFValue(0),
                        marginVertical : RFValue(15),
                    }}
                    source={{uri : `https://app.himoralanguagecenter.com/images/banner-word.png`}}
                />
            </View>



        </View>
    );
}

const styles = StyleSheet.create({



    container : {
        flex: 1,
        backgroundColor: Config.maincolor,
    },
    header: {
        flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems : 'center',

        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),

        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },
    headertxt : {
        fontFamily : 'ykb',
        fontSize : RFValue(18),
        marginVertical : RFValue(8),
        color : "#FFF",
    },
    subheadertxt : {
        fontFamily : 'yk',
        fontSize : RFValue(11),
        marginVertical : RFValue(8),
        color : "#E4E4E4",
        textAlign: "justify",
    },


    title : {
        fontSize: RFValue(17),
        fontFamily : 'ykb',
        color: '#FFF',
        paddingVertical: RFValue(14),

    },
    button: {
        backgroundColor: Config.secondcolor,
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        width :'90%',
        height : RFValue(45),
        marginVertical: RFValue(10),
        flexDirection : 'row',


        borderRadius: RFValue(10),

    },
    buttonText: {
        fontFamily: "yk",
        fontSize: RFValue(16),
        // color: Config.maincolor,
        color: 'white',
    },

})


export default Words